import React, { useState } from 'react';
import {
  Breakpoints,
  Tabs,
  TextAlignment,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

import { TabTitle } from './styles';
import { useMyVwContext } from '../../hooks/use-my-vw-context';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import { onVWBasicContentTabClickEvent } from '../../tagging/tagging-helpers';

interface TabItem {
  key: string;
  labelKey: string;
  content: React.ReactElement;
}

interface TabsContentProps {
  items: TabItem[];
}

const TabsContent: React.FC<TabsContentProps> = ({ items }) => {
  const { translationHandler } = useMyVwContext();
  const trackingManager = useTrackingManager();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleTabClick = (tabKey: string) => {
    try {
      // Track Security tab click specifically
      if (tabKey === 'security') {
        onVWBasicContentTabClickEvent(trackingManager, {
          Name: 'Account Settings',
          StepName: 'Personal Information and Security',
          StepNumber: '4',
        });
      }
    } catch (error) {
      console.warn('Error tracking tab click:', error);
    }
  };

  const tabItems = items.map((item, index) => ({
    title: (
      <TabTitle onClick={() => handleTabClick(item.key)}>
        <TextCustom
          appearance={TextAppearance.copy200}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              fontWeight: index === selectedIndex ? TextWeight.bold : TextWeight.regular,
              fontSize: TextSize.TextSize16,
              lineHeight: TextLineHeight.TextLineHeight20,
              textAlign: TextAlignment.left,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize20,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
          }}
        >
          {translationHandler(item.labelKey)}
        </TextCustom>
      </TabTitle>
    ),
    content: item.content,
    key: item.key,
  }));

  return (
    <Tabs variant="underlined" tabBarVerticalPosition="bottom" idPrefix="myvw" onChange={setSelectedIndex}>
      {tabItems}
    </Tabs>
  );
};

export default TabsContent;